import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-21444f3a")

_pushScopeId("data-v-21444f3a")
const _hoisted_1 = { id: "Top" }
const _hoisted_2 = { class: "top-screen" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Features = _resolveComponent("Features")
  const _component_TalkNow = _resolveComponent("TalkNow")
  const _component_TalkFuture = _resolveComponent("TalkFuture")
  const _component_All = _resolveComponent("All")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Features),
      _createVNode(_component_TalkNow),
      _createVNode(_component_TalkFuture),
      _createVNode(_component_All)
    ])
  ]))
})